var _style, _g, _g2, _g3, _g4, _g5, _rect, _rect2, _polyline, _circle, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 800,
    viewBox: "0 0 1440 800",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    .icon {\n      stroke: #0074c1;\n      stroke-width: 2;\n      fill: none;\n    }\n    .fill {\n      fill: #0074c1;\n    }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 180,
    stroke: "#0074c1",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 60,
    height: 15,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 45,
    width: 60,
    height: 15,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 70,
    width: 60,
    height: 15,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 95,
    width: 60,
    height: 15,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 120,
    width: 60,
    height: 15,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 145,
    width: 60,
    height: 15,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 160,
    width: 20,
    height: 20,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(620, 120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 180,
    stroke: "#0074c1",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20,
    width: 60,
    height: 15,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 45,
    width: 60,
    height: 15,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 70,
    width: 60,
    height: 15,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 95,
    width: 60,
    height: 15,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 120,
    width: 60,
    height: 15,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 145,
    width: 60,
    height: 15,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 160,
    width: 20,
    height: 20,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(400, 120)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 0,
    cy: 120,
    rx: 25,
    ry: 8,
    fill: "#E6F3FF",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0C-25 0 -40 15 -40 40C-40 65 0 100 0 100C0 100 40 65 40 40C40 15 25 0 0 0Z",
    stroke: "#0074c1",
    strokeWidth: 2.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 40,
    r: 18,
    stroke: "#0074c1",
    strokeWidth: 2,
    fill: "none"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(180, 380)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 70,
    height: 120,
    stroke: "#0074c1",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 15,
    width: 15,
    height: 15,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 15,
    width: 15,
    height: 15,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 40,
    width: 15,
    height: 15,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 40,
    width: 15,
    height: 15,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 65,
    width: 15,
    height: 15,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 65,
    width: 15,
    height: 15,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 90,
    width: 15,
    height: 15,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 90,
    width: 15,
    height: 15,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 30,
    width: 50,
    height: 90,
    stroke: "#0074c1",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 45,
    width: 12,
    height: 12,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 45,
    width: 12,
    height: 12,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 65,
    width: 12,
    height: 12,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 65,
    width: 12,
    height: 12,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 85,
    width: 12,
    height: 12,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 85,
    width: 12,
    height: 12,
    stroke: "#0074c1",
    strokeWidth: 1.5,
    fill: "none"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 80,
    width: 8,
    height: 8,
    stroke: "#0074c1",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 750,
    y: 100,
    width: 8,
    height: 8,
    stroke: "#0074c1",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 550,
    width: 8,
    height: 8,
    stroke: "#0074c1",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 520,
    width: 8,
    height: 8,
    stroke: "#0074c1",
    strokeWidth: 1,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 300L80 300",
    stroke: "#0074c1",
    strokeWidth: 1,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720 300L770 300",
    stroke: "#0074c1",
    strokeWidth: 1,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 320L50 320",
    stroke: "#0074c1",
    strokeWidth: 1,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750 320L770 320",
    stroke: "#0074c1",
    strokeWidth: 1,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 340L60 340",
    stroke: "#0074c1",
    strokeWidth: 1,
    strokeDasharray: "2 2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740 340L770 340",
    stroke: "#0074c1",
    strokeWidth: 1,
    strokeDasharray: "2 2"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "icon",
    x: 150,
    y: 580,
    width: 40,
    height: 100
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "icon",
    x: 200,
    y: 600,
    width: 30,
    height: 80
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "icon",
    points: "800,300 830,270 870,310 900,280"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "icon",
    cx: 830,
    cy: 270,
    r: 6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "icon",
    x: 1050,
    y: 500,
    width: 10,
    height: 10
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "icon",
    x: 1100,
    y: 530,
    width: 10,
    height: 10
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "icon",
    x: 980,
    y: 460,
    width: 10,
    height: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgIcons);
export default __webpack_public_path__ + "static/media/bgIcons.17c9db10d63693344788fa1283beae63.svg";
export { ForwardRef as ReactComponent };